import animationStyles from './animation-wrap.module.scss'

const ANIMATION_POPUP_TIME = 500 //ms

enum animationType {
  OVERLAY = 'OVERLAY',
  SIDEBAR = 'SIDEBAR',
}

const AnimationTypeVoc = {
  [animationType.OVERLAY]: {
    enter: animationStyles.overlayEnter,
    enterActive: animationStyles.overlayEnterActive,
    exit: animationStyles.overlayExit,
    exitActive: animationStyles.overlayExitActive,
  },
  [animationType.SIDEBAR]: {
    enter: animationStyles.contentEnter,
    enterActive: animationStyles.contentEnterActive,
    exit: animationStyles.contentExit,
    exitActive: animationStyles.contentExitActive,
  },
}

interface IAnimationWrap {
  animationType: animationType
  opened: boolean
}

export { AnimationTypeVoc, ANIMATION_POPUP_TIME, animationType }
export type { IAnimationWrap }
